module.exports = __webpack_public_path__ + "media/images/social_svgs/youtube-440a60085278bef531ee8b1d4e0ac337.svg";